import { NavLink, Link } from "react-router-dom";
import { Truck, ClipboardText, Archive, SignOut, ShieldCheck } from "@phosphor-icons/react";
import { clearSession } from "@/lib/api";

const navClass = ({ isActive }) =>
  `flex items-center gap-2 px-3 py-2 rounded-md text-sm font-semibold transition-colors duration-200 ${
    isActive
      ? "bg-orange-500 text-white"
      : "text-slate-300 hover:text-white hover:bg-slate-800"
  }`;

export default function SiteHeader({ session }) {
  return (
    <header className="bg-slate-900 border-b border-slate-800" data-testid="site-header">
      <div className="max-w-[1600px] mx-auto px-4 sm:px-6 lg:px-8 h-16 flex items-center justify-between">
        <Link to="/" className="flex items-center gap-3" data-testid="brand-link">
          <div className="bg-orange-500 text-white p-2 rounded-md">
            <Truck size={22} weight="duotone" />
          </div>
          <div>
            <div className="font-heading font-extrabold text-white tracking-tight leading-none">
              FREIGHT KPI
            </div>
            <div className="text-[11px] font-semibold uppercase tracking-[0.2em] text-slate-400">
              Doral &amp; Medley
            </div>
          </div>
        </Link>
        <div className="flex items-center gap-3">
          <nav className="flex items-center gap-2">
            <NavLink to="/" end className={navClass} data-testid="nav-today">
              <ClipboardText size={18} weight="duotone" />
              Today's Entry
            </NavLink>
            <NavLink to="/archives" className={navClass} data-testid="nav-archives">
              <Archive size={18} weight="duotone" />
              Archives
            </NavLink>
            {session.role === "admin" && (
              <NavLink to="/activity" className={navClass} data-testid="nav-activity">
                <ShieldCheck size={18} weight="duotone" />
                Activity
              </NavLink>
            )}
          </nav>
          <span
            className="hidden md:inline-flex items-center text-xs font-semibold text-slate-300 border border-slate-700 rounded px-2 py-1"
            data-testid="session-identity"
          >
            {session.role === "guest" ? "Guest · View only" : `${session.name} · ${session.role === "admin" ? "Admin" : session.warehouse === "doral" ? "Doral" : "Medley"}`}
          </span>
          <button
            data-testid="logout-btn"
            onClick={() => { clearSession(); window.location.reload(); }}
            className="inline-flex items-center gap-1.5 text-xs font-semibold text-slate-400 hover:text-white transition-colors duration-200"
          >
            <SignOut size={14} weight="bold" /> Switch user
          </button>
        </div>
      </div>
    </header>
  );
}
